import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import MainPage from "./MainPage";
import SettingsPage from "./SettingsPage";
//import UserEditPage from "./UserEditPage";
import InvalidLoginPage from "./InvalidLoginPage";
import ChangelogPage from "./ChangelogPage";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/main" element={<MainPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          {/*<Route path="/users/:user/edit" element={<UserEditPage />} />*/}
          <Route path="/test" element={<></>} />
          <Route path="/invalid" element={<InvalidLoginPage />} />
          <Route path="/changelog" element={<ChangelogPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
